module.exports = __webpack_public_path__ + "static/media/arrow.30b8bdb3.svg";